import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import API from "../APIs/API";
import { setEmployeeToken } from "../utils/helper";
import "../styles/login.scss";

const EmployeeLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.warning("Please enter your email."); return; }
    if (!password) { toast.warning("Please enter your password."); return; }
    setLoading(true);
    const result = await new API().employeeLogin(email.trim(), password);
    setLoading(false);
    if (result.status === true) {
      setEmployeeToken(result.data);
      navigate("/employee-portal");
    } else {
      toast.error(result.message || "Login failed.");
    }
  };

  return (
    <div className="login-page">
      <div className="box-form">
        <div className="left">
          <div className="overlay">
            <h1>PNG Time Access</h1>
            <p>Employee Self-Service Portal</p>
          </div>
        </div>
        <div className="right">
          <h5>Employee Login</h5>
          <p style={{ fontSize: 13, color: "#666", marginBottom: 12 }}>
            Sign in with your registered email address and password.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="inputs">
              <div>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <input
                  className="form-control"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  {showPassword ? " hide" : " show"}
                </span>
                <br />
              </div>
            </div>
            <button
              type="submit"
              className="loginbtn btn btn-primary btn-block mb-3"
              disabled={loading}
            >
              {loading ? "Signing in…" : "Login"}
            </button>
          </form>
          <Link to="/login" className="forgotpassword" style={{ textDecoration: "none" }}>
            <p>Administrator? Login here</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EmployeeLogin;
